/* eslint-disable */

import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Graphic from "@arcgis/core/Graphic";
import { NotificationManager } from "react-notifications";
import { ErrorHandelFunctionApp } from "./ErrorHandelFunction";
/**
 *
 * @param {string} url url of the layer
 * @param {object , array} objs attribute to add or array of attributes to add
 * @param {object} notificationMessages notification messages as object of success and error
 */
export default async function performActionOnFeature(
  {
    url,
    objs,
    action,
    notificationMessages = {},
    files = [],
    // form = null,
  } = null
) {
  const { onSuccessMessage, onErrorMessage } = notificationMessages;
  try {
    const featureLayerToCreate = new FeatureLayer({
      url,
    });

    let graphics;
    let layerAction = {};

    if (action === "add" || action === "update") {
      if (Array.isArray(objs)) {
        graphics = objs.map((obj) => {
          const graphic = new Graphic();
          graphic.attributes = {};
          Object.entries(obj).forEach(([key, value]) => {
            graphic.attributes[key] = value;
          });
          return graphic;
        });
      } else {
        const graphic = new Graphic();
        graphic.attributes = {};
        Object.entries(objs).forEach(([key, value]) => {
          graphic.attributes[key] = value;
        });
        graphics = [graphic];
      }
      if (action === "add")
        layerAction = {
          addFeatures: graphics,
        };
      if (action === "update")
        layerAction = {
          updateFeatures: graphics,
        };
    }

    if (action === "delete") {
      if (Array.isArray(objs)) {
        graphics = objs.map((obj) => {
          const graphic = new Graphic();
          graphic.attributes = obj;
          return graphic;
        });
      } else {
        const graphic = new Graphic();
        graphic.attributes = objs;
        graphics = [graphic];
      }
      layerAction = {
        deleteFeatures: graphics,
      };
    }
    const result = await featureLayerToCreate.applyEdits(layerAction);
    let findError = Object.values(result).find((item) => item.length);
    findError = findError ? findError[0] : null;
    if (onSuccessMessage && findError && !findError.error) {
      NotificationManager.success(onSuccessMessage || "Success");
    } else if (onErrorMessage) {
      NotificationManager.error(onErrorMessage || "Something Went Wrong");
    }

    // handle attachments
    if (files && files.length > 0) {
      let attachmentsResArr;
      if (action === "add") {
        const resultObjectId = result.addFeatureResults[0].objectId;
        const graphic = new Graphic();
        graphic.attributes = { OBJECTID: resultObjectId };
        attachmentsResArr = files.map((file) =>
          featureLayerToCreate.addAttachment(graphic, file)
        );
        await Promise.all(attachmentsResArr);
      } else {
        attachmentsResArr = files.map((file) => {
          const attachmentFeatureLayer = new FeatureLayer({
            url,
          });
          const attachmentGraphic = new Graphic();
          attachmentGraphic.attributes = { OBJECTID: objs.OBJECTID };
          return attachmentFeatureLayer.addAttachment(attachmentGraphic, file);
        });
        await Promise.all(attachmentsResArr);
      }
    }

    return result;
  } catch (error) {
    ErrorHandelFunctionApp(error)
  }
  return null;
}
